import { TaxFiling } from '@fruitful/types';

// 2025 Federal Tax Brackets (Single, Married Filing Jointly, Head of Household, Married Filing Separately)
export const FEDERAL_TAX_BRACKETS = {
    [TaxFiling.SINGLE]: [
        { threshold: 0, rate: 0.1 },
        { threshold: 11_926, rate: 0.12 },
        { threshold: 48_476, rate: 0.22 },
        { threshold: 103_351, rate: 0.24 },
        { threshold: 197_301, rate: 0.32 },
        { threshold: 250_526, rate: 0.35 },
        { threshold: 626_351, rate: 0.37 },
    ],
    [TaxFiling.MARRIED_FILING_JOINTLY]: [
        { threshold: 0, rate: 0.1 },
        { threshold: 23_851, rate: 0.12 },
        { threshold: 96_951, rate: 0.22 },
        { threshold: 206_701, rate: 0.24 },
        { threshold: 394_601, rate: 0.32 },
        { threshold: 501_051, rate: 0.35 },
        { threshold: 751_601, rate: 0.37 },
    ],
    [TaxFiling.HEAD_OF_HOUSEHOLD]: [
        { threshold: 0, rate: 0.1 },
        { threshold: 17_001, rate: 0.12 },
        { threshold: 64_851, rate: 0.22 },
        { threshold: 103_351, rate: 0.24 },
        { threshold: 197_301, rate: 0.32 },
        { threshold: 250_501, rate: 0.35 },
        { threshold: 626_351, rate: 0.37 },
    ],
    [TaxFiling.MARRIED_FILING_SEPARATELY]: [
        { threshold: 0, rate: 0.1 },
        { threshold: 11_926, rate: 0.12 },
        { threshold: 48_476, rate: 0.22 },
        { threshold: 103_351, rate: 0.24 },
        { threshold: 197_301, rate: 0.32 },
        { threshold: 250_526, rate: 0.35 },
        { threshold: 375_801, rate: 0.37 },
    ],
};
